import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { useSearchParams } from 'react-router-dom';
import { Container } from '@components/atoms/Container';
import { useTranslation } from 'react-i18next';

export function ValidateEmail() {
    const [searchParams] = useSearchParams();
    const isSuccess = searchParams.get('status') === 'success';
    const { t } = useTranslation();

    return (
        <MobileContainer>
            <Container>
                <div className="d-flex flex-column position-relative">
                    <div className="position-absolute start-0"></div>
                    {isSuccess ? (
                        <>
                            <h2>{t('email-verification.success.title')}</h2>
                            <p>{t('email-verification.success.message')}</p>
                        </>
                    ) : (
                        <>
                            <h2>{t('email-verification.error.title')}</h2>
                            <p>{t('email-verification.error.message')}</p>
                        </>
                    )}
                </div>
            </Container>
        </MobileContainer>
    );
}
